/**
 * Centralized speed profiles for horse movement animation.
 * Live vs history use different durations; history is faster for skippable replay.
 */

export const LIVE_STEP_DURATION_MS = 300;
export const LIVE_MID_STEP_DURATION_MS = 150;
export const HISTORY_STEP_DURATION_MS = 120;
/** Max duration for a single history segment (cap for long paths). */
export const HISTORY_MAX_SEGMENT_MS = 400;

export const SPEED_PROFILE_LIVE = 'live';
export const SPEED_PROFILE_HISTORY = 'history';

export function getStepDurationMs(
  speedProfile: string,
  isLastStep: boolean,
  segmentLength: number,
): number {
  if (speedProfile === SPEED_PROFILE_HISTORY) {
    const duration = HISTORY_STEP_DURATION_MS * Math.max(1, segmentLength);
    return Math.min(duration, HISTORY_MAX_SEGMENT_MS);
  }
  return isLastStep
    ? LIVE_STEP_DURATION_MS
    : LIVE_MID_STEP_DURATION_MS * Math.max(1, segmentLength);
}
